(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bungalow-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('.bungalow-hero').forEach(function (hero) {
      var slides = Array.from(hero.querySelectorAll('.bungalow-hero__slide'));
      var dots   = Array.from(hero.querySelectorAll('.bungalow-hero__dot'));
      var prev   = hero.querySelector('.bungalow-hero__arrow--prev');
      var next   = hero.querySelector('.bungalow-hero__arrow--next');

      if (slides.length < 2) return;

      var current  = 0;
      var timer    = null;
      var autoplay = hero.dataset.autoplay === 'true';
      var speed    = parseInt(hero.dataset.speed, 10) || 6000;

      function goTo(index) {
        slides[current].classList.remove('is-active');
        slides[current].setAttribute('aria-hidden', 'true');
        if (dots[current]) { dots[current].classList.remove('is-active'); dots[current].setAttribute('aria-selected', 'false'); }
        current = (index + slides.length) % slides.length;
        slides[current].classList.add('is-active');
        slides[current].removeAttribute('aria-hidden');
        if (dots[current]) { dots[current].classList.add('is-active'); dots[current].setAttribute('aria-selected', 'true'); }
      }

      function start() { if (autoplay) timer = setInterval(function () { goTo(current + 1); }, speed); }
      function stop()  { clearInterval(timer); }

      if (prev) prev.addEventListener('click', function () { stop(); goTo(current - 1); start(); });
      if (next) next.addEventListener('click', function () { stop(); goTo(current + 1); start(); });
      dots.forEach(function (dot) {
        dot.addEventListener('click', function () { stop(); goTo(parseInt(dot.dataset.index, 10)); start(); });
      });

      hero.addEventListener('mouseenter', stop);
      hero.addEventListener('mouseleave', start);

      start();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bungalow-cart__qty').forEach(function (wrap) {
      var input = wrap.querySelector('.bungalow-cart__qty-input');
      wrap.querySelector('[data-action="decrease"]').addEventListener('click', function () {
        var val = parseInt(input.value, 10);
        if (val > 1) input.value = val - 1;
      });
      wrap.querySelector('[data-action="increase"]').addEventListener('click', function () {
        input.value = parseInt(input.value, 10) + 1;
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"] && !Shopify.designMode) return;
  try {
    
  (function() {
    // ── Image carousel ──
    var mainImg = document.getElementById('bungalow-main-img');
    var thumbs = document.querySelectorAll('.bungalow-product__thumb');
    var dots = document.querySelectorAll('.bungalow-carousel__dot');
    var prevBtn = document.querySelector('.bungalow-carousel__arrow--prev');
    var nextBtn = document.querySelector('.bungalow-carousel__arrow--next');
    var currentIndex = 0;

    function setGalleryImage(index) {
      var thumb = thumbs[index];
      if (!thumb || !mainImg) return;
      mainImg.style.opacity = '0';
      setTimeout(function() {
        mainImg.src = thumb.dataset.src;
        mainImg.alt = thumb.dataset.alt;
        mainImg.style.opacity = '1';
      }, 150);
      thumbs.forEach(function(t) { t.classList.remove('bungalow-product__thumb--active'); });
      dots.forEach(function(d) { d.classList.remove('bungalow-carousel__dot--active'); });
      thumb.classList.add('bungalow-product__thumb--active');
      if (dots[index]) dots[index].classList.add('bungalow-carousel__dot--active');
      currentIndex = index;
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { setGalleryImage(i); });
    });

    dots.forEach(function(dot, i) {
      dot.addEventListener('click', function() { setGalleryImage(i); });
    });

    if (prevBtn) {
      prevBtn.addEventListener('click', function() {
        setGalleryImage((currentIndex - 1 + thumbs.length) % thumbs.length);
      });
    }

    if (nextBtn) {
      nextBtn.addEventListener('click', function() {
        setGalleryImage((currentIndex + 1) % thumbs.length);
      });
    }

    // ── Quantity stepper ──
    var qtyInput = document.querySelector('.bungalow-product__qty-input');
    document.querySelectorAll('.bungalow-product__qty-btn').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var current = parseInt(qtyInput.value) || 1;
        qtyInput.value = this.getAttribute('aria-label').includes('Decrease')
          ? Math.max(1, current - 1)
          : current + 1;
      });
    });

    // ── Variant switcher ──
    var variantRadios = document.querySelectorAll('input[name="variant-radio"]');
    var variantIdInput = document.getElementById('bungalow-variant-id');
    var priceEl = document.getElementById('bungalow-price');
    var atcBtn = document.getElementById('bungalow-atc');

    variantRadios.forEach(function(radio) {
      radio.addEventListener('change', function() {
        if (variantIdInput) variantIdInput.value = this.value;
        var price = parseInt(this.dataset.price);
        var compare = parseInt(this.dataset.compare);
        if (priceEl) {
          var html = '';
          if (compare && compare > price) {
            html += '<s class="bungalow-product__price-compare">$' + (compare / 100).toFixed(2) + '</s>';
          }
          html += '<span class="bungalow-product__price-current">$' + (price / 100).toFixed(2) + '</span>';
          priceEl.innerHTML = html;
        }
        if (atcBtn) {
          atcBtn.disabled = this.disabled;
          atcBtn.textContent = this.disabled ? 'Sold Out' : 'Add to Cart';
        }
      });
    });

    // ── Tab switching ──
    var tabBtns = document.querySelectorAll('.bungalow-tabs__tab');
    var tabPanels = document.querySelectorAll('.bungalow-tabs__panel');

    function activateTab(tab) {
      tabBtns.forEach(function(t) {
        t.classList.remove('bungalow-tabs__tab--active');
        t.setAttribute('aria-selected', 'false');
      });
      tabPanels.forEach(function(p) { p.hidden = true; });

      tab.classList.add('bungalow-tabs__tab--active');
      tab.setAttribute('aria-selected', 'true');

      var panel = document.getElementById(tab.getAttribute('aria-controls'));
      if (panel) {
        panel.hidden = false;
        panel.style.animation = 'none';
        panel.offsetHeight;
        panel.style.animation = '';
      }

      try { sessionStorage.setItem('bungalow-active-tab', tab.id); } catch(e) {}
    }

    tabBtns.forEach(function(tab, idx) {
      tab.addEventListener('click', function() { activateTab(this); });

      tab.addEventListener('keydown', function(e) {
        var newIdx;
        if (e.key === 'ArrowRight')     newIdx = (idx + 1) % tabBtns.length;
        else if (e.key === 'ArrowLeft') newIdx = (idx - 1 + tabBtns.length) % tabBtns.length;
        else if (e.key === 'Home')      newIdx = 0;
        else if (e.key === 'End')       newIdx = tabBtns.length - 1;
        else return;
        e.preventDefault();
        tabBtns[newIdx].focus();
        activateTab(tabBtns[newIdx]);
      });
    });

    try {
      var savedTabId = sessionStorage.getItem('bungalow-active-tab');
      if (savedTabId) {
        var savedTab = document.getElementById(savedTabId);
        if (savedTab) activateTab(savedTab);
      }
    } catch(e) {}
  })();

  } catch(e) { console.error(e); }
})();
})();
